<template lang="html">
  <div class="i-load-more-line">
    <div class="i-load-more-tip">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'i-load-more',
};
</script>

<style lang="scss" scoped>
.i-load-more-line {
  margin:20px auto auto auto;
  line-height:22px;
  font-size:14px;
  text-align:center;
  border-top:1px dashed #dddee1;
  .i-load-more-tip {
    display:inline-block;
    color:#495060;
    position: relative;
    top:-11px;
    padding:0 15px;
    background: #FFF;
  }
}
</style>
